module.exports = __webpack_public_path__ + "static/media/company-logo-2.85acf084.png";